import { type PropsWithChildren } from 'react';

import type { MaskingProps } from '../../../../../core/types/masking-props.js';
import { DataDtrumContext } from '../../../../core/context/DataDtrumContext.js';
import { MeterBarLayoutSizeContext } from '../../context/MeterBarLayoutSizeContext.js';
import { StoreProvider } from '../../providers/StoreProvider.js';
import type { MeterBarSize } from '../../types/meter-bars.js';

interface MeterBarSizeProvidersProps extends MaskingProps {
  size: MeterBarSize;
  chartHeight: number;
  chartWidth: number;
  segmentHeight: number;
  segmentWidth: number;
}

export const MeterBarSizeProviders = (
  props: PropsWithChildren<MeterBarSizeProvidersProps>,
) => {
  const {
    size,
    chartWidth,
    chartHeight,
    segmentWidth,
    segmentHeight,
    'data-dtrum-allow': dataDtrumAllow,
    'data-dtrum-mask': dataDtrumMask,
    children,
  } = props;

  return (
    // TODO use directly MeterBarLayoutSizeContext in MeterBarLayout and move DataDtrumContext to the root providers
    <DataDtrumContext.Provider value={{ dataDtrumAllow, dataDtrumMask }}>
      <MeterBarLayoutSizeContext.Provider
        value={{ size, chartWidth, chartHeight, segmentWidth, segmentHeight }}
      >
        <StoreProvider>{children}</StoreProvider>
      </MeterBarLayoutSizeContext.Provider>
    </DataDtrumContext.Provider>
  );
};
